import SelectorRoles from '../SelectorRoles';
import SelectorModulos from '../SelectorModulos';
import SelectorSubmodulos from '../SelectorSubmodulos';

export const rolsubmodSchema = {
 fields: [
   {
     name: 'idrol',
     type: 'custom',
     component: SelectorRoles,
     label: 'Rol',
     required: true,
     gridSpan: 'auto'
   },
   { name: 'idmodulos',
      type: 'custom',
      component: SelectorModulos,
      label: 'Módulo Padre',
      required: true,
      gridSpan: 'auto'
   },
   {
     name: 'idsubmodulos',
     type: 'custom',
     component: SelectorSubmodulos,
     label: 'Submódulo',
     required: true,
     gridSpan: 'auto'
   },
   {
     name: 'activo',
     type: 'checkbox',
     label: 'Relación activa',
     required: false,
     gridSpan: 'full'
   }
 ]
};